export * from './types';

// CATEGORICAL PALETTES
export * from './categorical/rainbowSurge';
export * from './categorical/blueberryTwilight';
export * from './categorical/mangoFusion';
export * from './categorical/cheerfulFiesta';

// SEQUENTIAL PALETTES
export * from './sequential/strawberrySky';

// SEQUENTIAL PALETTES - MONOCHROMATIC
export * from './sequential/blue';
export * from './sequential/cyan';
export * from './sequential/green';
export * from './sequential/orange';
export * from './sequential/pink';
export * from './sequential/purple';
export * from './sequential/red';
export * from './sequential/yellow';
